import * as React from 'react';
import { SVGProps } from 'react';

const IconFoldersSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1-1H5z" />
    <path d="M3 5H2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-1H4a1 1 0 0 1-1-1V5z" />
  </svg>
);
export default IconFoldersSizeS;
